export enum UserHomeIconNames {
    MyFavorites = 'fas fa-regular fa-star',
    MyAssignedAdmin = 'fas fa-regular fa-clipboard',
    MyDelegations = 'fas fa-solid fa-user-minus',
    DelegatedToMe = 'fas fa-solid fa-user-plus',
    MyDocCollabs = 'fas fa-solid fa-users',
    MyQAReviews = 'fas fa-solid fa-compass-drafting',
    MyDocFormattings = 'fas fa-solid fa-pen-to-square',
    MyDocReviews='fas fa-eye',
    MyDocApprovals = 'fas fa-regular fa-circle-check',
    MyChangeRequests = 'fa-regular fa-lightbulb',
    MyPeriodicReviews = 'fas fa-calendar-days',
    MyHardcopyActivities = 'fas fa-solid fa-print',
    MyAcknowledgements = 'fas fa-regular fa-thumbs-up',
    MyClientSignatures='fa-solid fa-file-signature',
    MyQuarantinedDocuments = 'fas fa-file-shield'
}

export enum UserHomeTrainingIconNames {
    MyPendingTrainings = 'fas fa-graduation-cap pr-4',
    MyTrainingPlanReviews  = 'fas fa-eye'   
}